module.exports = __webpack_public_path__ + "img/16d001-23.daafcee6.jpg";